module.exports = __webpack_public_path__ + "d67cddea7d1a581b41984776b6ef34ff.svg";